import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "white",
  },
  section: {
    margin: 10,
    padding: 20,
    flexGrow: 1,
  },
  title: {
    fontSize: 24,
    marginBottom: 10,
    textAlign: "center",
  },
  text: {
    font: "times new roman",
    fontSize: 14,
    marginBottom: 5,
    fontWeight: "bold",
    textAlign: "center",
  },

  text1: {
    font: "times new roman",
    fontSize: 12,
    marginTop: 20,
  },
  text2: {
    font: "times new roman",
    fontSize: 12,
    marginTop: 5,
  },
  text3: {
    font: "times new roman",
    fontSize: 12,
    marginTop: 5,
    textDecoration: "underline",
  },
  text4: {
    font: "times new roman",
    fontSize: 12,
    marginTop: 20,
    fontWeight: "bolder",
  },

  text5: {
    fontWeight: "bold",
    textAlign: "center",
    font: "times new roman",
    fontSize: 12,
    marginTop: 20,
  },
  text6: {
    fontWeight: "bold",
    textAlign: "left",
    fontSize: 12,
    marginTop: 20,
  },
  text7: {
    fontWeight: "bold",
    marginLeft: 100,
    fontSize: 12,
  },
});

function ContractPDF(props) {
  const contractDetail = props.contractDetail;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.text}>
            {" "}
            {contractDetail ? contractDetail.contractType : ""}
          </Text>
          <Text style={styles.text1}> Entre les soussignés :</Text>
          <Text style={styles.text2}>
            La Société IWARE, société de services sise Avenue Habib Bourguiba,
            Tunis registre de commerce N°555555555 représentée par son gérant Mr
            Slim Ben Slim.
          </Text>
          <Text style={styles.text3}> d’une part ,</Text>
          <Text style={styles.text2}>
            {contractDetail
              ? contractDetail.gender === "homme"
                ? "Monsieur"
                : "Madame"
              : null}{" "}
            ,
            {contractDetail
              ? contractDetail.firstname + " " + contractDetail.lastname
              : ""}{" "}
            Tunisien(ne), née en Tunisie le{" "}
            {contractDetail ? contractDetail.datenais : ""} , titulaire de la
            carte d’identité nationale n°{" "}
            {contractDetail ? contractDetail.cin : ""} et demeurant à{" "}
            {contractDetail ? contractDetail.adr : ""}{" "}
            {contractDetail ? contractDetail.country : ""}{" "}
            {contractDetail ? contractDetail.postalCode : ""}.
          </Text>
          <Text style={styles.text3}> d’autre part,</Text>
          <Text style={styles.text4}>
            Il a été arrêté et convenu ce qui suit :
          </Text>
          <Text style={styles.text3}>ARTICLE 1 : Engagement</Text>

          <Text style={styles.text4}>
            {" "}
            La Société IWARE, engage aux termes du présent contrat de travail{" "}
            {contractDetail
              ? contractDetail.gender === "homme"
                ? "Monsieur"
                : "Madame"
              : null}{" "}
            {contractDetail
              ? contractDetail.firstname + " " + contractDetail.lastname
              : ""}
            , qui l’accepte, de travailler en tant que{" "}
            {contractDetail ? contractDetail.nomPost : ""}. Le présent contrat
            sera régi par les dispositions légales, réglementaires et
            conventionnelles applicables au secteur d’activité.
          </Text>
          <Text style={styles.text3}>ARTICLE 2 : Horaires de travail</Text>
          <Text style={styles.text4}>
            {" "}
            Le présent contrat est conclu et accepté pour un horaire de travail
            de {contractDetail ? contractDetail.nb_hrs_mois : ""} heures par
            mois.
          </Text>
          <Text style={styles.text3}>ARTICLE 3 : Durée du contrat</Text>
          <Text style={styles.text4}>
            {" "}
            Le présent contrat est conclu et accepté pour une durée de{" "}
            {contractDetail ? contractDetail.duree : ""} commençant le{" "}
            {contractDetail ? contractDetail.date_deb : ""} et finissant le{" "}
            {contractDetail ? contractDetail.date_fin : ""}.
          </Text>

          <Text style={styles.text3}>ARTICLE 4 : Rémunération</Text>
          <Text style={styles.text4}>
            {" "}
            En contrepartie de l’accomplissement de ses fonctions,{" "}
            {contractDetail
              ? contractDetail.gender === "homme"
                ? "Monsieur"
                : "Madame"
              : null}{" "}
            {contractDetail
              ? contractDetail.firstname + " " + contractDetail.lastname
              : ""}{" "}
            percevra un salaire fixe mensuel net de huit cent dinars (
            {contractDetail ? contractDetail.montant_brut : ""} ).
          </Text>
          <Text style={styles.text3}>
            ARTICLE 5 : Obligations professionnelles
          </Text>
          <Text style={styles.text4}>
            {" "}
            {contractDetail
              ? contractDetail.gender === "homme"
                ? "Monsieur"
                : "Madame"
              : null}{" "}
            {contractDetail
              ? contractDetail.firstname + " " + contractDetail.lastname
              : ""}{" "}
            s’engage formellement : - A consacrer tout son temps au service où
            il est affecté, suivant l’horaire établi par la direction de
            l’établissement. - A se conformer aux instructions qui lui seront
            données par les personnes sous les ordres desquelles il est placé. -
            A observer le secret professionnel et à ne faire, sans
            l’autorisation écrite de ses chefs, aucune communication écrite ou
            verbale à des tiers sur les questions se rattachant aux travaux pour
            lesquels il est engagé. - A prendre soin du matériel qui lui sera
            confié. - Et d’une façon générale à respecter les lois et règlements
            généraux ou particuliers en vigueur.
          </Text>
          <Text style={styles.text3}>ARTICLE 6 : Dispositions diverses</Text>
          <Text style={styles.text4}>
            {" "}
            {contractDetail
              ? contractDetail.gender === "homme"
                ? "Monsieur"
                : "Madame"
              : null}{" "}
            {contractDetail
              ? contractDetail.firstname + " " + contractDetail.lastname
              : ""}{" "}
            déclare formellement n’être lié à aucune autre entreprise, être
            libre de tout engagement. En outre,{" "}
            {contractDetail
              ? contractDetail.gender === "homme"
                ? "Monsieur"
                : "Madame"
              : null}{" "}
            {contractDetail
              ? contractDetail.firstname + " " + contractDetail.lastname
              : ""}{" "}
            s’engage à faire connaître, sans délai, tout changement qui
            interviendrait dans sa situation, concernant son adresse, situation
            familiale…
          </Text>

          <Text style={styles.text5}>
            Fait à Tunisie le {contractDetail ? contractDetail.dateRec : " "} ,
          </Text>
          <Text style={styles.text4}>
            <Text style={styles.text6}>Signature et cachet </Text>{" "}
            <Text style={styles.text7}> </Text>{" "}
            <Text style={styles.text7}></Text>
            <Text style={styles.text7}>
              Signature légalisée de du acteur ou actrice l’employeur
            </Text>{" "}
          </Text>
        </View>
      </Page>
    </Document>
  );
}

export default ContractPDF;
